import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-so-content',
  templateUrl: './so-content.component.html',
  styleUrls: ['./so.component.scss']
})

export class SoContentComponent {

  @Input() isActive = false;

}
